import { formatINR } from "@/lib/quotationApi";

export default function PublicNotices({
  snapshotMode,
  canRecompute,
  hasExclusions,
  showSavings,
  savingsNet,
}) {
  return (
    <>
      {/* Customise hint (only when the customer can toggle items) */}
      {!snapshotMode && canRecompute && (
        <div
          className="rounded-xl border border-[#C5A880]/25 bg-[#C5A880]/[0.05] px-4 py-3 mb-5 text-sm text-white/70"
          data-testid="public-customise-hint"
        >
          Tap the checkbox next to any line item or accessory to include or
          exclude it — the totals below update instantly so you can explore
          options. Your changes are private and don't affect the saved quote.
        </div>
      )}

      {/* Customisation note (shown on-screen + in the PDF snapshot) */}
      {hasExclusions && (
        <div
          className="rounded-xl border border-amber-400/30 bg-amber-400/[0.07] px-4 py-2.5 mb-4 text-[13px] text-amber-200/90"
          data-testid="public-customisation-note"
        >
          Struck-through items are <span className="font-semibold">excluded</span> from
          the totals below.
        </div>
      )}

      {/* Savings badge — how much the customer's selection changes the total */}
      {showSavings && (
        <div
          data-testid="public-savings-badge"
          className={`rounded-xl border px-4 py-3 mb-4 flex items-center justify-between gap-3 ${
            savingsNet > 0
              ? "border-emerald-400/30 bg-emerald-400/[0.08]"
              : "border-sky-400/30 bg-sky-400/[0.08]"
          }`}
        >
          <span
            className={`text-[13px] ${savingsNet > 0 ? "text-emerald-200/90" : "text-sky-200/90"}`}
          >
            {savingsNet > 0
              ? "You're saving vs the full quote"
              : "You've added to the quote"}
          </span>
          <span
            className={`font-display font-bold text-lg sm:text-xl ${
              savingsNet > 0 ? "text-emerald-300" : "text-sky-300"
            }`}
            data-testid="public-savings-amount"
          >
            {savingsNet > 0 ? "−" : "+"}
            {formatINR(Math.abs(savingsNet))}
          </span>
        </div>
      )}
    </>
  );
}
